import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { useQuery } from "react-query";
import { ISetPointListReportModel  } from "../../services/admin-report-data-service/Models";
import AdminReportDataService from "../../services/admin-report-data-service/AdminReportDataService";

export type UseAlarmSetpointReportParamsV2 = {
    organizationID: number,    
    contextGroupID: number,
    includeInActiveAndInvisibleDevices: boolean,
} & BaseUseQueryParameters<ISetPointListReportModel | undefined>;

export function useAlarmSetpointReportV2({
    organizationID,
    contextGroupID,
    includeInActiveAndInvisibleDevices,
    enabled,    
    onSuccess,
    onError
}: UseAlarmSetpointReportParamsV2) {
    return useQuery<ISetPointListReportModel, RestError>(
        keys.alarmSetpointReportV2(organizationID, contextGroupID, includeInActiveAndInvisibleDevices),
        ({ signal }) => {
            return AdminReportDataService.getAlarmSetpointReportV2(
                organizationID,
                contextGroupID,
                includeInActiveAndInvisibleDevices,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
        }
    );
}